/* SAGLOU locale navigation bridge · only internal links; no redirects, no cart logic overrides. */
(()=>{
'use strict';
const data=document.getElementById('saglou-locale-navigation');
if(!data)return;
const locale=(data.dataset.locale||'').toLowerCase();
const suppliedRoot=(data.dataset.root||'/').replace(/\/+$/,'')+'/';
if(locale==='es'||locale.startsWith('es-'))return;
const first=location.pathname.split('/').filter(Boolean)[0]||'';
let root=suppliedRoot;
if(first===locale||first.startsWith(locale+'-'))root='/'+first+'/';
if(!root.startsWith('/')||root==='//')root='/';
if(root==='/')return;
const storefrontRoutes=/^\/(products|collections|pages|policies|blogs|cart|search|account|apps)(\/|$)/;
function localize(a){
 if(!a||!a.getAttribute||a.hasAttribute('download'))return;
 const raw=a.getAttribute('href');
 if(!raw||raw[0]==='#'||raw[0]==='?'||/^(?:mailto:|tel:|javascript:|data:)/i.test(raw))return;
 let url;
 try{url=new URL(raw,location.href)}catch{return}
 if(url.origin!==location.origin)return;
 const path=url.pathname;
 if(path===root.slice(0,-1)||path.startsWith(root))return;
 if(path!=='/'&&!storefrontRoutes.test(path))return;
 const newPath=(root+path.replace(/^\//,'')).replace(/\/{2,}/g,'/');
 const next=newPath+url.search+url.hash;
 if(raw!==next)a.setAttribute('href',next);
}
function walk(scope){
 if(!scope)return;
 if(scope.nodeType===1&&scope.matches?.('a[href]'))localize(scope);
 scope.querySelectorAll?.('a[href]').forEach(localize);
}
function start(){
 walk(document);
 const observer=new MutationObserver(events=>{
  for(const ev of events){
   if(ev.type==='attributes'){localize(ev.target);continue;}
   for(const n of ev.addedNodes)if(n.nodeType===1)walk(n);
  }
 });
 observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
 // Capture-phase helps links created by scripts on user clicks, without preventing normal navigation.
 ['click','auxclick','contextmenu','touchstart'].forEach(name=>{
  document.addEventListener(name,e=>localize(e.target.closest?.('a[href]')),true);
 });
 document.addEventListener('shopify:section:load',e=>walk(e.target));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
